import { useCallback, useMemo, useState } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';

// @ts-expect-error untyped import
import UIValidatedEmailFormControl from 'ui-addon-form-validation/Email/UIValidatedEmailFormControl';
import { CopyTextArea } from 'foundations-components/transitional/components/CopyTextArea';
import embedScriptHelper from 'MeetingsAdmin/utils/embedScriptHelper';
import { ButtonGroup } from 'foundations-components/transitional/components/ButtonGroup';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { SlideoutDrawer } from 'foundations-components/transitional/components/SlideoutDrawer';
import { CopyButton } from 'foundations-components/transitional/components/CopyButton';
import { H7 } from 'foundations-components/transitional/components/H7';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function SelectEmbedStyleV2({
  link,
  onSendEmbedCodeEmail
}) {
  const [showEmailForm, setShowEmailForm] = useState(false);
  const [emailAddress, setEmailAddress] = useState('');
  const [isValidEmail, setIsValidEmail] = useState(false);
  const handleEmailValidateSuccess = useCallback(() => {
    setIsValidEmail(true);
  }, []);
  const handleEmailValidateError = useCallback(() => {
    setIsValidEmail(false);
  }, []);
  const toggleEmailForm = useCallback(() => {
    setShowEmailForm(!showEmailForm);
  }, [showEmailForm]);
  const renderedMessage = useMemo(() => {
    return {
      success: '',
      error: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "validatedFormControl.validationMessageDefaults.email.error"
      })
    };
  }, []);
  const renderedEmailForm = useMemo(() => {
    return /*#__PURE__*/_jsxs(SlideoutDrawer, {
      open: showEmailForm,
      children: [/*#__PURE__*/_jsx(UIValidatedEmailFormControl, {
        validationMessage: renderedMessage,
        onSuccess: handleEmailValidateSuccess,
        onError: handleEmailValidateError,
        children: /*#__PURE__*/_jsx(TextInput, {
          type: "email",
          placeholder: I18n.text('createLinkModal.setupEmbed.emailCode.placeholder'),
          onChange: event => setEmailAddress(event.target.value)
        })
      }), /*#__PURE__*/_jsx(Button, {
        marginBlockStart: "300",
        type: "submit",
        size: "small",
        use: "tertiary",
        onClick: () => onSendEmbedCodeEmail(emailAddress, link.id),
        disabled: !isValidEmail,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "buttons.sendMessage"
        })
      })]
    });
  }, [emailAddress, handleEmailValidateError, handleEmailValidateSuccess, isValidEmail, link.id, onSendEmbedCodeEmail, renderedMessage, showEmailForm]);
  const scriptText = embedScriptHelper(link.link);
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    children: [/*#__PURE__*/_jsx(H7, {
      marginBlockEnd: "100",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "createLinkModal.setupEmbed.copyCode.header"
      })
    }), /*#__PURE__*/_jsxs(Text, {
      as: "small",
      marginBlockEnd: "100",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "createLinkModal.setupEmbed.copyCode.description"
      }), /*#__PURE__*/_jsx(HelpIcon, {
        alignWithText: true,
        marginInlineStart: "100",
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "createLinkModal.setupEmbed.copyCode.helpText"
        })
      })]
    }), /*#__PURE__*/_jsx(CopyTextArea, {
      "data-selenium-test": "embed-code-textarea",
      use: "code",
      inlineSize: "100%",
      value: scriptText,
      buttonRowRenderer: props => /*#__PURE__*/_jsxs(ButtonGroup, {
        marginBlockStart: "300",
        children: [/*#__PURE__*/_jsx(CopyButton, Object.assign({
          size: "xs"
        }, props, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "buttons.copyCode"
          })
        })), /*#__PURE__*/_jsx(Button, {
          size: "xs",
          onClick: toggleEmailForm,
          use: "tertiary-light",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "buttons.emailCode"
          })
        })]
      })
    }), renderedEmailForm]
  });
}
export default SelectEmbedStyleV2;